import Utils from './utils';

class Notices {
  constructor(NoticesType = 'default', customContainer = null) {
    let selector = '.js-km-awards-notices';

    if (NoticesType === 'inline') {
      selector += '-inline';
    }

    this.notice = customContainer || document.querySelector(selector);

    if (!this.notice) {
      return;
    }

    this.defaults = {
      message: '',
      type: 'error',
      dismissDelay: 0,
      bold: true,
      spinner: false,
      forceClose: false,
      scrollTo: true,
      scrollToOffset: 10,
    };

    this.noticeContent = this.notice.querySelector('.js-km-awards-notices-content');
    this.noticeClose = this.notice.querySelector('.js-km-awards-notices-close');

    this.allTypes = ['is-error', 'is-success', 'is-warning'];

    this.noticeCloseHandler();
  }

  noticeCloseHandler() {
    if (this.noticeClose) {
      this.noticeClose.addEventListener('click', () => {
        this.hideNotice();
      });
    }
  }

  getElement() {
    return this.notice;
  }

  showNotice = (args) => {
    if (!this.notice) {
      return;
    }

    const params = { ...this.defaults, ...args };
    const { message, type, dismissDelay, bold, forceClose, scrollTo, scrollToOffset } = params;

    if (this.t) {
      clearTimeout(this.t);
    }

    let messageHtml = '';
    let boldTagOpen = '';
    let boldTagClose = '';
    const spinner = params.spinner ? '<span class="spinner is-active"></span>' : '';

    if (bold) {
      boldTagOpen = '<strong>';
      boldTagClose = '</strong>';
    }

    if (Array.isArray(message)) {
      messageHtml = message.map((item) => `<p>${boldTagOpen}${item}${boldTagClose}</p>`).join('');
    } else {
      messageHtml = `<p>${boldTagOpen}${message}${boldTagClose}</p>`;
    }

    if (spinner) {
      messageHtml = spinner + messageHtml;
    }

    this.notice.classList.remove(...this.allTypes);

    this.notice.classList.add('is-active', `is-${type}`);
    this.noticeContent.innerHTML = messageHtml;

    if (dismissDelay > 0) {
      this.t = setTimeout(() => {
        this.hideNotice();
      }, dismissDelay);
    }

    if (this.noticeClose) {
      if (dismissDelay === 0 || forceClose === true) {
        this.noticeClose.style.display = 'block';
      } else {
        this.noticeClose.style.display = 'none';
      }
    }

    if (scrollTo) {
      Utils.scrollTo(this.notice, scrollToOffset);
    }
  };

  hideNotice = () => {
    if (!this.notice) {
      return;
    }

    this.notice.classList.remove('is-active');

    if (this.t) {
      clearTimeout(this.t);
    }
  };
}

export default Notices;
